import '@css/main.css'
import Alpine from 'alpinejs'
import {navigation} from './components/navigation'

// Register Alpine components
declare global {
    interface Window {
        Alpine: typeof Alpine
    }
}

Alpine.data('navigation', navigation)

// Create Alpine store for scroll state
Alpine.store('scrolled', false)

// Listen to scroll events and update Alpine store
document.addEventListener('DOMContentLoaded', () => {
    const updateScrollState = () => {
        Alpine.store('scrolled', window.scrollY > 50)
    }

    // Initial check
    updateScrollState()

    // Update on scroll
    document.addEventListener('scroll', updateScrollState, {passive: true})
})

// Make Alpine available globally
window.Alpine = Alpine

Alpine.start()
